import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as marketActions from 'actions/gia_ca_thi_truong';
import SlideMarketPrices from '../../marketPrice/components/SlideMarketPrices';
import { imageUrl } from '../../../lib';

function RelatedItems(props) {
  const { catalogueName, catalogueImage, catalogueId, currentMarketPriceId, marketActions, listMarketPrices } = props;
  const { fetchAllMarketPrices } = marketActions;

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Gọi action fetch data
  const fetchData = () => {
    setIsLoading(true);
    fetchAllMarketPrices({
      limit: 4,
      market_place_catalogue_id: catalogueId,
      reject_id: currentMarketPriceId,
    });
  };

  // Khi redux store thay đổi
  useEffect(() => {
    const newData = Array.isArray(listMarketPrices?.data) ? listMarketPrices.data : [];

    setData(newData);

    setIsLoading(false);
  }, [listMarketPrices]);
  // Khi catalogueId hoặc ID của bài viết hiện tại thay đổi
  useEffect(() => {
    if (!catalogueId) {
      console.warn('catalogueId is missing!');
      return;
    }
    fetchData();
  }, [catalogueId, currentMarketPriceId]);

  return (
    Array.isArray(data) &&
    data.length > 0 && (
      <div className="mkt-price-hist">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span className="icon-store"></span>
            <span className="txt">Giá cùng loại mặt hàng</span>
          </div>
        </div>
        <div className="card col-12 mb-2 pt-2">
          <div className="list-inline-item form-control-range">
            <div className="ml-2">
              <img
                src={imageUrl(catalogueImage)}
                className="rounded-circle image-thumnail box-category"
                alt="icon category"
              />
              <strong className="primary-clr ml-2">{catalogueName}</strong>
            </div>
          </div>
          <div className="cont-center saved-items mkt-price mt-2">
            {isLoading ? (
              <div className="text-center p-3">Đang tải dữ liệu...</div>
            ) : (
              <SlideMarketPrices
                marketPrices={data}
                catalogue={{ name: catalogueName, image: catalogueImage, id: catalogueId }}
              />
            )}
          </div>
        </div>
      </div>
    )
  );
}

const mapStateToProps = state => ({
  listMarketPrices: state.market.listMarketPrices,
  listProvinces: state.location.listProvinces,
  listFollowingMarketPrices: state.market.followingMarketPrice,
});

const mapDispatchToProps = dispatch => ({
  marketActions: bindActionCreators(marketActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RelatedItems);
